import React from 'react';
import {Domain, User} from "../types";


export default class DomainHelper {
  static getClientDomain(user: User, domainsToAlternate: Domain[]): Domain | undefined {
    for (let i = 0; i < domainsToAlternate.length; i++) {
      const domain = domainsToAlternate[i];
      if (domain.id === user.domain) {
        return domain;
      }
    }
    return undefined;
  }

  static getDefaultSeoDomain(domainsToAlternate: Domain[]): Domain | undefined {
    for (let i = 0; i < domainsToAlternate.length; i++) {
      const domain = domainsToAlternate[i];
      if (domain.live && domain.defaultCulture === 'en_US' && !domain.custom) {
        return domain;
      }
    }
    return undefined;
  }

  static renderAlternate(domain: Domain | undefined, path: string): JSX.Element | undefined {
    if (domain) {
      return (
        <link
          key={`${domain.href}`}
          rel="alternate"
          hrefLang={domain.hreflang}
          href={`${domain.href}${path}`}
        />
      );
    }
    return undefined;
  }

  static renderCanonical(domain: Domain | undefined, path: string): JSX.Element | undefined {
    if (domain) {
      return <link rel="canonical" href={`${domain.href}${path}`} />;
    }
    return undefined;
  }
}
